

export const aiTemplateCategoryTypes = [
  { label: '脱衣', value: 1 },
  { label: '视频换脸', value: 2 },
  { label: '图片换脸', value: 3 },
]